import { supplierState, supplierFormState } from "../types/index"

export const initialFormState: supplierFormState = {
    vendorName:    "",
    telephone:     "",
    fax:           "",
    contact:       "",
    address:       "",
    headerGroupId: 0,
    phoneOffice:   "",
    headline:      "",
}

export const initialState: supplierState = {
    loading:        false,
    data:           [],
    error:          "",
    form:           initialFormState,
    isAddModalOpen: false,
}